import { useState } from "react";
import { useNavigate } from "react-router";

export type useColdexTableRowMenuProps = {};

export default function useColdexTableRowMenu() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const open = Boolean(anchorEl);

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleCloseConfirm() {
    setOpenConfirm(false);
  }

  function handleOptionUpdateDbClick() {
    setOpenConfirm(true);
    handleClose();
  }

  function handleOptionRedirectReportClick(coldexId: number) {
    navigate(`${coldexId}/report`);
    handleClose();
  }

  return {
    anchorEl,
    openConfirm,
    open,
    handleClick,
    handleClose,
    handleCloseConfirm,
    handleOptionUpdateDbClick,
    handleOptionRedirectReportClick,
  };
}
